import React from "react";
import LandingPage from "../groupPlanningFeature/LandingPage";

const GroupPlanningPage: React.FC = () => {
  return <LandingPage />;
};

export default GroupPlanningPage;
